import React, { ReactElement } from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { ReactComponent as WarningIcon } from 'assets/alerts/warningOutline.svg';
import { ReactComponent as InfoIcon } from 'assets/alerts/info.svg';
import { ReactComponent as ErrorIcon } from 'assets/alerts/error.svg';
import { ReactComponent as VersionIcon } from 'assets/icon/copy.svg';
import { MessageType } from 'components/Popper';
export { MessageType } from 'components/Popper';

const getBGColorFromType = ({ theme, type }: { type: MessageType; theme: DefaultTheme }) => {
  if (type === MessageType.INFO || type === MessageType.VERSION) {
    return theme.colors.paleBlue;
  } else if (type === MessageType.ERROR) {
    return theme.colors.palePink;
  } else {
    return theme.colors.earlyDawn;
  }
};

const getColorFromType = ({ theme, type }: { type: MessageType; theme: DefaultTheme }) => {
  if (type === MessageType.INFO || type === MessageType.VERSION) {
    return theme.colors.malibu;
  } else if (type === MessageType.ERROR) {
    return theme.colors.radicalRed;
  } else {
    return theme.colors.orange;
  }
};

type FieldMessageProps = {
  id?: string;
  isShowIcon?: boolean;
  children: ReactElement | string;
  type: MessageType;
  className?: string;
  style?: React.CSSProperties;
  display?: string;
};

const Message = styled.p<{ type: MessageType; display?: string }>`
  background-color: ${getBGColorFromType};
  color: ${getColorFromType};

  padding: 5px 8px;
  border-radius: 6px;
  line-height: 1.4;
  margin: 0;
  display: inline-flex;

  ${({ display }) =>
    display &&
    `
    display: ${display ?? 'block'};
  `}
  > span {
    font-size: 11px;
    font-weight: 500;
    color: ${getColorFromType} !important;
  }
`;

const Icon = ({ id, type }: { id: string; type: MessageType }) => {
  if (type === MessageType.INFO) {
    return (
      <InfoIcon
        id={id}
        style={{
          marginRight: 8,
          width: 14,
          height: 14,
          position: 'relative',
          top: 1,
        }}
      />
    );
  } else if (type === MessageType.ERROR) {
    return (
      <ErrorIcon
        id={id}
        style={{
          marginRight: 8,
          width: 14,
          height: 14,
          position: 'relative',
          top: 1,
        }}
      />
    );
  } else if (type === MessageType.VERSION) {
    return (
      <VersionIcon
        id={id}
        style={{
          marginRight: 8,
          width: 14,
          height: 14,
          position: 'relative',
          top: 1,
        }}
      />
    );
  } else {
    return (
      <WarningIcon
        id={id}
        style={{
          marginRight: 8,
          width: 14,
          height: 14,
          position: 'relative',
          top: -1,
        }}
      />
    );
  }
};

export const Link = styled.span`
  text-decoration: underline;
  color: inherit;
  display: inline-block;
  cursor: pointer;
`;

const FieldMessage = ({
  id,
  isShowIcon = true,
  type,
  children,
  className,
  ...props
}: FieldMessageProps) => {
  return (
    <Message id={`${id}-fieldmessage`} type={type} className={className} {...props}>
      {isShowIcon && <Icon id={`${id}-fieldmessage-svg`} type={type} />}
      <span>{children}</span>
    </Message>
  );
};

export default FieldMessage;
